/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const NullEnum = zod.literal(null);

export type NullEnum = zod.input<typeof NullEnum>;
export type NullEnumOutput = zod.output<typeof NullEnum>;
